import script from "./AddActivityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddActivityForm.vue?vue&type=script&setup=true&lang=js"

import "./AddActivityForm.vue?vue&type=style&index=0&id=e146ed1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e146ed1a"]])

export default __exports__